import { CampaignStatus, CampaignType, RecurrenceEndMode, RecurrenceFrequency, RecurrencePattern, RecurrenceWeekOfMonth, ToListType, UserStatus } from "./enums";

export const campaignStatusOptions = Object.entries(CampaignStatus).map(
  ([key, value]) => ({
    key,
    text: value,
    value,
  })
);

export const userStatusOptions = [
  { key: '1', value: UserStatus.ACTIVE, text: UserStatus.ACTIVE },
  { key: '2', value: UserStatus.DEACTIVE, text: UserStatus.DEACTIVE },
]

export const campaignTypeOptions = Object.entries(CampaignType).map(
  ([key, value]) => ({
    key,
    text: value,
    value,
  })
);

export const toListTypeOptions = Object.entries(ToListType).map(
  ([key, value]) => ({
    key,
    text: key.charAt(0) + key.slice('1').toLowerCase(),
    value,
  })
);

export const optionMaker = (data, { key = 'name', text = 'name', value = 'id' } = {}) => {
  const formattedOption = data.reduce((acc, v, index) => {
    acc[v[value]] = {
      value: v[value],
      text: v[text],
      key: `${v[key]}-${index}`,
    };
    return acc;
  }, {});
  return formattedOption
}

export const mapMaker = (data, { key = 'name', text = 'name', value = 'id' } = {}) => {
  const formattedOption = data.reduce((acc, v, index) => {
    acc[v[value]] = {
      value: v[value],
      text: v[text],
      label: v[text],
      key: `${v[key]}-${index}`,
      ...v
    };
    return acc;
  }, {});
  return formattedOption
} 

export const recurrenceFrequencyOptions = [
  { key: 'weekly', value: RecurrenceFrequency.WEEKLY, text: 'Weekly' },
  { key: 'monthly', value: RecurrenceFrequency.MONTHLY, text: 'Monthly' },
];

export const recurrencePatternOptions = [
  { key: 'day_of_month', value: RecurrencePattern.DAY_OF_MONTH, text: 'On a specific day of the month' },
  { key: 'last_day_of_month', value: RecurrencePattern.LAST_DAY_OF_MONTH, text: 'On the last day of the month' },
  { key: 'nth_weekday', value: RecurrencePattern.NTH_WEEKDAY, text: 'On a specific weekday (e.g. first Tuesday)' },
];

export const recurrenceEndModeOptions = [
  { key: 'indefinite', value: RecurrenceEndMode.INDEFINITE, text: 'Run indefinitely, until stopped' },
  { key: 'end_date', value: RecurrenceEndMode.END_DATE, text: 'Stop on a specific date' },
];

export const dayOfWeekOptions = [
  { key: '0', value: '0', text: 'Sunday' },
  { key: '1', value: '1', text: 'Monday' },
  { key: '2', value: '2', text: 'Tuesday' },
  { key: '3', value: '3', text: 'Wednesday' },
  { key: '4', value: '4', text: 'Thursday' },
  { key: '5', value: '5', text: 'Friday' },
  { key: '6', value: '6', text: 'Saturday' },
];

export const weekOfMonthOptions = [
  { key: 'first', value: RecurrenceWeekOfMonth.FIRST, text: 'First' },
  { key: 'second', value: RecurrenceWeekOfMonth.SECOND, text: 'Second' },
  { key: 'third', value: RecurrenceWeekOfMonth.THIRD, text: 'Third' },
  { key: 'fourth', value: RecurrenceWeekOfMonth.FOURTH, text: 'Fourth' },
  { key: 'last', value: RecurrenceWeekOfMonth.LAST, text: 'Last' },
];

export const timezoneOptions = [
  // India Standard Time (IST)
  { key: 'Asia/Kolkata', value: 'Asia/Kolkata', text: 'India Standard Time - Mumbai, Kolkata, New Delhi, Bengaluru (Asia/Kolkata)' },

  // Middle East
  { key: 'Asia/Dubai', value: 'Asia/Dubai', text: 'Gulf Standard Time - Dubai, Abu Dhabi, UAE (Asia/Dubai)' },
  { key: 'Asia/Riyadh', value: 'Asia/Riyadh', text: 'Arabia Standard Time - Riyadh, Saudi Arabia (Asia/Riyadh)' },
  { key: 'Asia/Qatar', value: 'Asia/Qatar', text: 'Arabia Standard Time - Doha, Qatar (Asia/Qatar)' },

  // Other Asia Countries
  { key: 'Asia/Singapore', value: 'Asia/Singapore', text: 'Singapore Standard Time - Singapore (Asia/Singapore)' },
  { key: 'Asia/Tokyo', value: 'Asia/Tokyo', text: 'Japan Standard Time - Tokyo (Asia/Tokyo)' },
  { key: 'Asia/Bangkok', value: 'Asia/Bangkok', text: 'Indochina Time - Bangkok, Thailand (Asia/Bangkok)' },

  // Eastern Time (ET)
  { key: 'America/New_York', value: 'America/New_York', text: 'Eastern Time - New York, Boston, Miami, Atlanta (America/New_York)' },
  { key: 'America/Detroit', value: 'America/Detroit', text: 'Eastern Time - Michigan (America/Detroit)' },
  { key: 'America/Indiana/Indianapolis', value: 'America/Indiana/Indianapolis', text: 'Eastern Time - Indiana (America/Indiana/Indianapolis)' },
  { key: 'America/Kentucky/Louisville', value: 'America/Kentucky/Louisville', text: 'Eastern Time - Louisville, KY (America/Kentucky/Louisville)' },

  // Central Time (CT)
  { key: 'America/Chicago', value: 'America/Chicago', text: 'Central Time - Chicago, Dallas, Houston, Nashville (America/Chicago)' },
  { key: 'America/Indiana/Knox', value: 'America/Indiana/Knox', text: 'Central Time - Northwest Indiana (America/Indiana/Knox)' },
  { key: 'America/North_Dakota/Center', value: 'America/North_Dakota/Center', text: 'Central Time - North Dakota (America/North_Dakota/Center)' },

  // Mountain Time (MT)
  { key: 'America/Denver', value: 'America/Denver', text: 'Mountain Time - Denver, Salt Lake City (America/Denver)' },
  { key: 'America/Phoenix', value: 'America/Phoenix', text: 'Mountain Time - Arizona / no DST (America/Phoenix)' },
  { key: 'America/Boise', value: 'America/Boise', text: 'Mountain Time - Boise, Southern Idaho (America/Boise)' },

  // Pacific Time (PT)
  { key: 'America/Los_Angeles', value: 'America/Los_Angeles', text: 'Pacific Time - Los Angeles, San Francisco, Seattle (America/Los_Angeles)' },

  // Alaska & Aleutian Time (AKT / HAST)
  { key: 'America/Anchorage', value: 'America/Anchorage', text: 'Alaska Time - Anchorage, Fairbanks, Juneau (America/Anchorage)' },
  { key: 'America/Adak', value: 'America/Adak', text: 'Hawaii-Aleutian Time - Adak, Aleutian Islands (America/Adak)' },

  // Hawaii Time (HT)
  { key: 'Pacific/Honolulu', value: 'Pacific/Honolulu', text: 'Hawaii Time - Honolulu / no DST (Pacific/Honolulu)' },

  // US Territories
  { key: 'America/Puerto_Rico', value: 'America/Puerto_Rico', text: 'Atlantic Time - Puerto Rico, US Virgin Islands (America/Puerto_Rico)' },
  { key: 'Pacific/Guam', value: 'Pacific/Guam', text: 'Chamorro Standard Time - Guam, Saipan (Pacific/Guam)' },
  { key: 'Pacific/Pago_Pago', value: 'Pacific/Pago_Pago', text: 'Samoa Time - American Samoa (Pacific/Pago_Pago)' },

  // UTC
  { key: 'UTC', value: 'UTC', text: 'UTC - Coordinated Universal Time' },
];

export const Months = [
  { text: 'January', value: '01', key: '01' },
  { text: 'February', value: '02', key: '02' },
  { text: 'March', value: '03', key: '03' },
  { text: 'April', value: '04', key: '04' },
  { text: 'May', value: '05', key: '05' },
  { text: 'June', value: '06', key: '06' },
  { text: 'July', value: '07', key: '07' },
  { text: 'August', value: '08', key: '08' },
  { text: 'September', value: '09', key: '09' },
  { text: 'October', value: '10', key: '10' },
  { text: 'November', value: '11', key: '11' },
  { text: 'December', value: '12', key: '12' }
];
